import { toRGBA } from "./utils";

const sonic = [90, 136, 237];
const s = (opacity: number = 1) =>
  toRGBA(sonic[0], sonic[1], sonic[2], opacity);

export default s;
